var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1449.86 850.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        letter-spacing: 0em;\n      }\n\n      .cls-2 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-3 {\n        letter-spacing: .02em;\n      }\n\n      .cls-4 {\n        letter-spacing: .03em;\n      }\n\n      .cls-5 {\n        letter-spacing: 0em;\n      }\n\n      .cls-6 {\n        letter-spacing: 0em;\n      }\n\n      .cls-7 {\n        isolation: isolate;\n      }\n\n      .cls-8 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-9 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-10 {\n        letter-spacing: -.05em;\n      }\n\n      .cls-11 {\n        letter-spacing: 0em;\n      }\n\n      .cls-12 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-13 {\n        fill: #06b6db;\n      }\n\n      .cls-14 {\n        letter-spacing: -.06em;\n      }\n\n      .cls-15 {\n        letter-spacing: -.05em;\n      }\n\n      .cls-16 {\n        letter-spacing: -.05em;\n      }\n\n      .cls-17 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-18 {\n        letter-spacing: .01em;\n      }\n\n      .cls-19 {\n        letter-spacing: 0em;\n      }\n\n      .cls-20 {\n        fill: #000708;\n      }\n\n      .cls-21 {\n        fill: #898989;\n      }\n\n      .cls-22 {\n        letter-spacing: 0em;\n      }\n\n      .cls-23 {\n        letter-spacing: .04em;\n      }\n\n      .cls-24 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-25 {\n        letter-spacing: .03em;\n      }\n\n      .cls-26 {\n        letter-spacing: 0em;\n      }\n\n      .cls-27 {\n        letter-spacing: 0em;\n      }\n\n      .cls-28 {\n        letter-spacing: 0em;\n      }\n\n      .cls-29 {\n        letter-spacing: 0em;\n      }\n\n      .cls-30 {\n        letter-spacing: 0em;\n      }\n\n      .cls-31 {\n        letter-spacing: 0em;\n      }\n\n      .cls-32 {\n        fill: #003153;\n        font-family: Nunito-Regular, Nunito;\n        font-size: 20.07px;\n        font-variation-settings: 'wght' 400;\n      }\n\n      .cls-33 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-34 {\n        letter-spacing: 0em;\n      }\n\n      .cls-35 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-36 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-37 {\n        fill: #bcc7c9;\n      }\n\n      .cls-38 {\n        fill: #7b0d1e;\n      }\n\n      .cls-39 {\n        letter-spacing: -.06em;\n      }\n\n      .cls-40 {\n        letter-spacing: 0em;\n      }\n\n      .cls-41 {\n        letter-spacing: 0em;\n      }\n\n      .cls-42 {\n        letter-spacing: 0em;\n      }\n\n      .cls-43 {\n        letter-spacing: 0em;\n      }\n\n      .cls-44 {\n        mix-blend-mode: overlay;\n        opacity: .44;\n      }\n\n      .cls-45 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-46 {\n        letter-spacing: 0em;\n      }\n\n      .cls-47 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-48 {\n        fill: #5e361b;\n      }\n\n      .cls-49 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-50 {\n        letter-spacing: 0em;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m1243.19,97.96c-4.06-7.45-114.36,33.34-213.81,66.81-44.99,3.25-100.32,6.83-133.02,6.56,27.64-16.07,69.63-28.83,83.04-31.66,76.17-16.05,176.05-67.42,159.97-82.96-3.92-3.79-39.4-.19-94.02,9.08,1.15-1.31,1.55-2.58,1.09-3.81-4.01-10.57-13.92-13.29-22.41-13.5,30.75-3.99,100.63-15.38,97.06-36.21-2.7-15.74-202.87,54.72-371.46,117.85-146.64,37.53-300.53,85.29-394.86,134-64.95,33.54-101.61,75.92-120.54,119.22-13.28,14.03-21.03,28.82-24.19,46.7-4.76,26.91-.17,52.85,10.04,77.59,7.83,48.85,28.13,85.73,37.19,92.78,22.85,17.78,205.67,197.03,348.88,208.89,143.21,11.85,219.41-32.71,218.63-38.58-.57-4.28-70.22-47.6-107.84-70.7-1.33-2.98-2.71-6.05-4.15-9.24,0,0-14.6-7.92-35.14-21.51-44.66-48.24-162.55-190.33-68.46-255.52,121.88-84.44,386.73-209.99,390.69-212.17,48.66-26.69,260.4-72.22,243.3-103.62Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m729.84,735.21c7.38-2.06,17.27,1.76,25.1,1.46,9.52-.37,18.97-2.42,27.76-6.1,27.81-11.65,46.17-37.01,69.85-54.58,19.67-14.59,60.33-28.77,81.85-10.24,21.98,18.92,28.01,79.62-55.1,102.95-32.38,9.09-66.99,3.82-98.13-7.45-11.98-4.34-23.63-9.61-34.83-15.67-5.13-2.78-12.89-5.96-16.5-10.37Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "create"
  }, /*#__PURE__*/React.createElement("g", {
    id: "paintbrush"
  }, /*#__PURE__*/React.createElement("path", {
    id: "splash",
    className: "cls-37",
    d: "m135.39,158.77s304,29.33,654.04-20.66c350.87-50.12,481.33,100.71,518.3,168.54,36.97,67.83-360.53,91.4-310.27,158.5,24.86,33.2,42.81,36.65,183.67,96.65,140.86,60,83.68,144.66-5.12,145.94-88.8,1.28,43.36,50.03,9.57,78.88-60.14,51.36-1186.48,87.52-1052.27,8.01,26.81-15.88,57.43-55.66,95.76-91.04,25.54-23.57-162.61-23.36-196.75-59.33-98.46-103.75,141.68-122.38,239.39-140.07,22.64-4.1-270.17-53.11-157.64-129.95,43.44-29.66,78.22-21.33,62.22-49.78-33.85-60.18-109.55-158.69-40.9-165.69Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "stroke"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bottom",
    className: "cls-13",
    d: "m693.29,687.03s-198.6-192.72-84.28-271.93c121.88-84.44,386.73-209.99,390.69-212.17,48.66-26.69,260.4-72.22,243.3-103.62-7.37-13.53-365.18,132.05-371.95,103.94-6.77-28.11,86.83-57.73,108.17-62.22,76.17-16.05,176.05-67.42,159.97-82.96-16.08-15.54-563.69,93.33-784.6,207.4-214.77,110.9-120.36,318.51-97.5,336.29,22.85,17.78,205.67,197.03,348.88,208.89,143.21,11.85,219.41-32.71,218.63-38.58s-131.31-85.05-131.31-85.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dark",
    className: "cls-13",
    d: "m700.42,691.82s-159.96-93.01-153.87-189.3c6.09-96.29,314.74-305.13,550.47-340.39,39.61-5.93-197.02,17.43-225.97,8.55-23.65-7.26,141.68-53.33,53.32-47.41-88.36,5.93-181.29,57.78-137.11,25.18,44.18-32.59,266.61-65.02,258.99-85.1-7.62-20.08-36.56-11.85-36.56-11.85,0,0,115.78-11.19,111.21-37.86-4.57-26.67-575.88,194.07-600.25,207.4-214.4,117.27-298.31,139.75-310.79,210.37-13.81,78.11,51.11,147.96,103.6,204.44,0,0,163.54,175.97,423.53,149.4,8.98-.92,4.08-3.72-36.57-93.43Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m1243.19,97.96c-4.06-7.45-114.36,33.34-213.81,66.81-44.99,3.25-100.32,6.83-133.02,6.56,27.64-16.07,69.63-28.83,83.04-31.66,76.17-16.05,176.05-67.42,159.97-82.96-3.92-3.79-39.4-.19-94.02,9.08,1.15-1.31,1.55-2.58,1.09-3.81-4.01-10.57-13.92-13.29-22.41-13.5,30.75-3.99,100.63-15.38,97.06-36.21-2.7-15.74-202.87,54.72-371.46,117.85-146.64,37.53-300.53,85.29-394.86,134-64.95,33.54-101.61,75.92-120.54,119.22-13.28,14.03-21.03,28.82-24.19,46.7-4.76,26.91-.17,52.85,10.04,77.59,7.83,48.85,28.13,85.73,37.19,92.78,22.85,17.78,205.67,197.03,348.88,208.89,143.21,11.85,219.41-32.71,218.63-38.58-.57-4.28-70.22-47.6-107.84-70.7-1.33-2.98-2.71-6.05-4.15-9.24,0,0-14.6-7.92-35.14-21.51-44.66-48.24-162.55-190.33-68.46-255.52,121.88-84.44,386.73-209.99,390.69-212.17,48.66-26.69,260.4-72.22,243.3-103.62Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-32",
    transform: "translate(63.2 51.94) rotate(-27.34) scale(1.24 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "impo"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 44.69,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 52.39,
    y: 0
  }, "t "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 64.59,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 73.96,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 84.1,
    y: 0
  }, "x"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 94.63,
    y: 0
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    x: 106.19,
    y: 0
  }, "y as cp"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 24.08
  }, "impo"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 44.69,
    y: 24.08
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 52.39,
    y: 24.08
  }, "t matp"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 111.13,
    y: 24.08
  }, "lo"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 128.02,
    y: 24.08
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 135.16,
    y: 24.08
  }, "li"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-35",
    x: 145.76,
    y: 24.08
  }, "b"), /*#__PURE__*/React.createElement("tspan", {
    x: 157.02,
    y: 24.08
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 161.59,
    y: 24.08
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    x: 173.15,
    y: 24.08
  }, "yp"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 195.16,
    y: 24.08
  }, "lo"), /*#__PURE__*/React.createElement("tspan", {
    x: 212.06,
    y: 24.08
  }, "t as p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 261.42,
    y: 24.08
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 267.18,
    y: 24.08
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 48.16
  }, "impo"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 44.69,
    y: 48.16
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 52.39,
    y: 48.16
  }, "t num"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 104.42,
    y: 48.16
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    x: 115.98,
    y: 48.16
  }, "y as np"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 96.32
  }, "num"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 39.83,
    y: 96.32
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 52.63,
    y: 96.32
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 63.79,
    y: 96.32
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 70.85,
    y: 96.32
  }, "d = 20"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 0,
    y: 120.4
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 6.58,
    y: 120.4
  }, "s = c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 47.92,
    y: 120.4
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 59.17,
    y: 120.4
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 62.71,
    y: 120.4
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 75.39,
    y: 120.4
  }, "ariab"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 120.2,
    y: 120.4
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 126.04,
    y: 120.4
  }, "e((2, 1))"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 144.48
  }, "d = c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-35",
    x: 43.38,
    y: 144.48
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 54.64,
    y: 144.48
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-39",
    x: 58.17,
    y: 144.48
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    x: 70.85,
    y: 144.48
  }, "ariab"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 115.66,
    y: 144.48
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    x: 121.5,
    y: 144.48
  }, "e((num"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 184.73,
    y: 144.48
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 197.53,
    y: 144.48
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 208.69,
    y: 144.48
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 215.75,
    y: 144.48
  }, "d, 1))"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 168.56
  }, "x"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 10.53,
    y: 168.56
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 23.34,
    y: 168.56
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 34.49,
    y: 168.56
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 41.56,
    y: 168.56
  }, "d = "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 75.65,
    y: 168.56
  }, "["), /*#__PURE__*/React.createElement("tspan", {
    x: 82.77,
    y: 168.56
  }, "]"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 192.64
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 10.31,
    y: 192.64
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 23.12,
    y: 192.64
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 34.27,
    y: 192.64
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 41.34,
    y: 192.64
  }, "d = "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 75.43,
    y: 192.64
  }, "["), /*#__PURE__*/React.createElement("tspan", {
    x: 82.55,
    y: 192.64
  }, "]"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 0,
    y: 216.72
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 9.09,
    y: 216.72
  }, "on"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 31.64,
    y: 216.72
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 41.2,
    y: 216.72
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 48.22,
    y: 216.72
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 55.3,
    y: 216.72
  }, "aints = "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 121.06,
    y: 216.72
  }, "["), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 127.18,
    y: 216.72
  }, "d &gt;= 0]"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 264.88
  }, "obj"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-49",
    x: 27.59,
    y: 264.88
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    x: 38.37,
    y: 264.88
  }, "un = c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 92.71,
    y: 264.88
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 103.96,
    y: 264.88
  }, ".Minimi"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 168.23,
    y: 264.88
  }, "z"), /*#__PURE__*/React.createElement("tspan", {
    x: 177.32,
    y: 264.88
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 188,
    y: 264.88
  }, "("), /*#__PURE__*/React.createElement("tspan", {
    x: 194.16,
    y: 264.88
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-35",
    x: 203.45,
    y: 264.88
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    x: 214.71,
    y: 264.88
  }, ".max"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 257.63,
    y: 264.88
  }, "("), /*#__PURE__*/React.createElement("tspan", {
    x: 263.79,
    y: 264.88
  }, "d))"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 337.11
  }, "# c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 26.51,
    y: 337.11
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 33.57,
    y: 337.11
  }, "ea"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 54.88,
    y: 337.11
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 61.8,
    y: 337.11
  }, "e 20 "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 106.91,
    y: 337.11
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 114,
    y: 337.11
  }, "andom"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-49",
    x: 176.06,
    y: 337.11
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    x: 181.78,
    y: 337.11
  }, "y gene"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 241.78,
    y: 337.11
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 248.86,
    y: 337.11
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 259.5,
    y: 337.11
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 266.42,
    y: 337.11
  }, "ed "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 293.97,
    y: 337.11
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 303.06,
    y: 337.11
  }, "oo"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 325.37,
    y: 337.11
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 332.44,
    y: 337.11
  }, "dina"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 370.82,
    y: 337.11
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 377.75,
    y: 337.11
  }, "es append "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-43",
    x: 476.23,
    y: 337.11
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 483.15,
    y: 337.11
  }, "o "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 499.49,
    y: 337.11
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 506.63,
    y: 337.11
  }, "he"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 361.19
  }, "# "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 17.22,
    y: 361.19
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 26.31,
    y: 361.19
  }, "or"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 44.65,
    y: 361.19
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 51.71,
    y: 361.19
  }, "ect li"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 94.47,
    y: 361.19
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 104.02,
    y: 361.19
  }, "ts "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-43",
    x: 125.87,
    y: 361.19
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 132.8,
    y: 361.19
  }, "o be used la"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 241.72,
    y: 361.19
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 248.64,
    y: 361.19
  }, "er"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-36",
    x: 0,
    y: 385.27
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 6.4,
    y: 385.27
  }, "or x in "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 66.86,
    y: 385.27
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 73.94,
    y: 385.27
  }, "ange(num"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 164.6,
    y: 385.27
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 177.4,
    y: 385.27
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 188.56,
    y: 385.27
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 195.62,
    y: 385.27
  }, "d):"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 409.35,
    xmlSpace: "preserve"
  }, "    p = n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-35",
    x: 66.2,
    y: 409.35
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    x: 77.46,
    y: 409.35
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 82.03,
    y: 409.35
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 89.11,
    y: 409.35
  }, "andom"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-43",
    x: 151.18,
    y: 409.35
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 155.65,
    y: 409.35
  }, "uni"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-36",
    x: 182.96,
    y: 409.35
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 189.36,
    y: 409.35
  }, "orm(0, 10, si"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 301.17,
    y: 409.35
  }, "z"), /*#__PURE__*/React.createElement("tspan", {
    x: 310.26,
    y: 409.35
  }, "e=(2, 1))"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 433.43,
    xmlSpace: "preserve"
  }, "    x"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 31.24,
    y: 433.43
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 44.05,
    y: 433.43
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 55.2,
    y: 433.43
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 62.27,
    y: 433.43
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 73.96,
    y: 433.43
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 78.46,
    y: 433.43
  }, "ap"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 100.79,
    y: 433.43
  }, "pv"), /*#__PURE__*/React.createElement("tspan", {
    x: 122.54,
    y: 433.43
  }, "end(p[00])"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 457.51,
    xmlSpace: "preserve"
  }, "    y"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 31.02,
    y: 457.51
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 43.82,
    y: 457.51
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 54.98,
    y: 457.51
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 62.04,
    y: 457.51
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 73.74,
    y: 457.51
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 78.24,
    y: 457.51
  }, "append(p[1][0])"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 481.59,
    xmlSpace: "preserve"
  }, "    # add "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 77.13,
    y: 481.59
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 84.28,
    y: 481.59
  }, "he l2 norm "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 186.77,
    y: 481.59
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 195.86,
    y: 481.59
  }, "on"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 218.42,
    y: 481.59
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 227.97,
    y: 481.59
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 234.99,
    y: 481.59
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 242.08,
    y: 481.59
  }, "aints "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 290.62,
    y: 481.59
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 297.02,
    y: 481.59
  }, "or each u - w"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 505.67,
    xmlSpace: "preserve"
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 20.71,
    y: 505.67
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.8,
    y: 505.67
  }, "on"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 52.35,
    y: 505.67
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 61.9,
    y: 505.67
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 68.93,
    y: 505.67
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 76.01,
    y: 505.67
  }, "aint"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 109.72,
    y: 505.67
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-50",
    x: 119.27,
    y: 505.67
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 123.77,
    y: 505.67
  }, "append(v"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 529.75,
    xmlSpace: "preserve"
  }, "        d[x] &gt;= c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-35",
    x: 120.01,
    y: 529.75
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    x: 131.27,
    y: 529.75
  }, ".norm2("), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 201.16,
    y: 529.75
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 207.74,
    y: 529.75
  }, "s - "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 236.26,
    y: 529.75
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 247.76,
    y: 529.75
  }, ")"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 553.83,
    xmlSpace: "preserve"
  }, "    )"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 601.99
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 11.7,
    y: 601.99
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 18.76,
    y: 601.99
  }, "ob = c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-35",
    x: 73.3,
    y: 601.99
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    x: 84.56,
    y: 601.99
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 89.13,
    y: 601.99
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 101.64,
    y: 601.99
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 108.7,
    y: 601.99
  }, "ob"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 131.55,
    y: 601.99
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 137.39,
    y: 601.99
  }, "em"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-47",
    x: 165.24,
    y: 601.99
  }, "("), /*#__PURE__*/React.createElement("tspan", {
    x: 171.4,
    y: 601.99
  }, "obj"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 199,
    y: 601.99
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    x: 209.77,
    y: 601.99
  }, "un, "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 242.18,
    y: 601.99
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 251.27,
    y: 601.99
  }, "on"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 273.82,
    y: 601.99
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 283.37,
    y: 601.99
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 290.4,
    y: 601.99
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 297.48,
    y: 601.99
  }, "aints)"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 626.07
  }, "model = p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 90.74,
    y: 626.07
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 97.8,
    y: 626.07
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-35",
    x: 108.96,
    y: 626.07
  }, "b"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 120.22,
    y: 626.07
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 124.87,
    y: 626.07
  }, "so"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-49",
    x: 145.68,
    y: 626.07
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 151.4,
    y: 626.07
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 161.59,
    y: 626.07
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 172.27,
    y: 626.07
  }, "("), /*#__PURE__*/React.createElement("tspan", {
    x: 179.43,
    y: 626.07
  }, ")"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 650.15
  }, "# prints solu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-42",
    x: 112.01,
    y: 650.15
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 119.15,
    y: 650.15
  }, "ion"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 674.23
  }, "print("), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 48.32,
    y: 674.23
  }, "fs"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 64.45,
    y: 674.23
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 68.04,
    y: 674.23
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 78.18,
    y: 674.23
  }, "alu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 106.01,
    y: 674.23
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 116.48,
    y: 674.23
  }, ")"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 698.31
  }, "print(mode"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 99.03,
    y: 698.31
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 105.59,
    y: 698.31
  }, ")"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 746.47
  }, "# add "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-42",
    x: 56.43,
    y: 746.47
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 63.57,
    y: 746.47
  }, "he an"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 112.85,
    y: 746.47
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 122.3,
    y: 746.47
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 139.04,
    y: 746.47
  }, "er "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 162.07,
    y: 746.47
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 169,
    y: 746.47
  }, "o "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-42",
    x: 185.33,
    y: 746.47
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 192.47,
    y: 746.47
  }, "he "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 219.72,
    y: 746.47
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 228.81,
    y: 746.47
  }, "oo"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 251.13,
    y: 746.47
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 258.19,
    y: 746.47
  }, "dina"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 296.58,
    y: 746.47
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 303.5,
    y: 746.47
  }, "e li"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 329.95,
    y: 746.47
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 339.5,
    y: 746.47
  }, "ts"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 770.55
  }, "x"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 10.53,
    y: 770.55
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 23.34,
    y: 770.55
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 34.49,
    y: 770.55
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 41.56,
    y: 770.55
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 53.26,
    y: 770.55
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 57.75,
    y: 770.55
  }, "append("), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 131.91,
    y: 770.55
  }, "fs"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 148.05,
    y: 770.55
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 151.64,
    y: 770.55
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 161.77,
    y: 770.55
  }, "alue[0][0])"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 794.63
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 10.31,
    y: 794.63
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 23.12,
    y: 794.63
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 34.27,
    y: 794.63
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 41.34,
    y: 794.63
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 53.03,
    y: 794.63
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 57.53,
    y: 794.63
  }, "append("), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 131.69,
    y: 794.63
  }, "fs"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 147.83,
    y: 794.63
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 151.42,
    y: 794.63
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 161.55,
    y: 794.63
  }, "alue[1][0])"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 842.79
  }, "# g"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 28.98,
    y: 842.79
  }, "re"), /*#__PURE__*/React.createElement("tspan", {
    x: 46.59,
    y: 842.79
  }, "y "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-36",
    x: 62.08,
    y: 842.79
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 68.49,
    y: 842.79
  }, "or "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-42",
    x: 92,
    y: 842.79
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 99.15,
    y: 842.79
  }, "he "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 126.4,
    y: 842.79
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 133.48,
    y: 842.79
  }, "andom"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-49",
    x: 195.54,
    y: 842.79
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    x: 201.26,
    y: 842.79
  }, "y gene"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 261.26,
    y: 842.79
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 268.34,
    y: 842.79
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-43",
    x: 278.98,
    y: 842.79
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 285.9,
    y: 842.79
  }, "ed villages"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 866.87
  }, "c = [&apos;g"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 54.2,
    y: 866.87
  }, "re"), /*#__PURE__*/React.createElement("tspan", {
    x: 71.82,
    y: 866.87
  }, "y&apos;] * num"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 152.1,
    y: 866.87
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 164.9,
    y: 866.87
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 176.06,
    y: 866.87
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 183.12,
    y: 866.87
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-40",
    x: 0,
    y: 915.03
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 9.49,
    y: 915.03
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 13.99,
    y: 915.03
  }, "append(&apos;"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 92.58,
    y: 915.03
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 99.65,
    y: 915.03
  }, "ed&apos;)"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 939.1
  }, "# g"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 28.98,
    y: 939.1
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.06,
    y: 939.1
  }, "aph"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 963.18
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-41",
    x: 11.7,
    y: 963.18
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 17.46,
    y: 963.18
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 24.76,
    y: 963.18
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 29.42,
    y: 963.18
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 39.07,
    y: 963.18
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 48.28,
    y: 963.18
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 58.91,
    y: 963.18
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 65.68,
    y: 963.18
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 72.6,
    y: 963.18
  }, "er(x"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 107.35,
    y: 963.18
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 120.16,
    y: 963.18
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 131.31,
    y: 963.18
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 138.38,
    y: 963.18
  }, "d, y"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 170.14,
    y: 963.18
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 182.94,
    y: 963.18
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 194.1,
    y: 963.18
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 201.16,
    y: 963.18
  }, "d, "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 222.61,
    y: 963.18
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 231.7,
    y: 963.18
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 242.86,
    y: 963.18
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    x: 248.7,
    y: 963.18
  }, "or="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-40",
    x: 279.08,
    y: 963.18
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 288.57,
    y: 963.18
  }, ")"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 987.26
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-41",
    x: 11.7,
    y: 987.26
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 17.46,
    y: 987.26
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 24.76,
    y: 987.26
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 29.42,
    y: 987.26
  }, "sh"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 50.47,
    y: 987.26
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 61.48,
    y: 987.26
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 78.36,
    y: 987.26
  }, "("), /*#__PURE__*/React.createElement("tspan", {
    x: 85.52,
    y: 987.26
  }, ")"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 0,
    y: 1011.34
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 10.72,
    y: 1011.34
  }, "v")))), /*#__PURE__*/React.createElement("g", {
    id: "top",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m574.7,591.47s-225.48-182.22,129.5-321.48c354.97-139.26,100.55-17.78-123.4,105.18-55.54,30.5-6.09,216.29-6.09,216.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m248.09,554.29s43.55,46.98,97.5,103.7c56.37,59.26,111.21,90.37,111.21,90.37,0,0-111.21-96.29-138.64-158.52-27.42-62.22-70.08-35.55-70.08-35.55Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "brush"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m1028.62,531.79l-104.86,127.99,17.5,14.34,116.4-123.11c-2.67-26.87-27.11-21.55-27.11-21.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m1028.62,531.79s285.93-344.32,329.52-385.45c72.58-68.51,115.18-74.75,37,28.48-73.86,97.52-337.47,376.19-337.47,376.19,0,0-5.06-20.6-29.04-19.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m1027.73,532.89s-3.28-2.69.96-6.25c3.22-2.71,20.63,1.09,31.67,21.1,2.03,3.68-2.87,7.7-4.48,5.47-8.15-11.25-16.8-17.42-28.15-20.32Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m729.84,735.21c7.38-2.06,17.27,1.76,25.1,1.46,9.52-.37,18.97-2.42,27.76-6.1,27.81-11.65,46.17-37.01,69.85-54.58,19.67-14.59,60.33-28.77,81.85-10.24,21.98,18.92,28.01,79.62-55.1,102.95-32.38,9.09-66.99,3.82-98.13-7.45-11.98-4.34-23.63-9.61-34.83-15.67-5.13-2.78-12.89-5.96-16.5-10.37Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m809.61,694.23c2.39,3.78,20.86,48.17,64.25,39.84,43.39-8.33,33.92,17.73,33.92,17.73l-42.16,33.33s-142.44,10.13-148.39-29.48c-5.94-39.61,92.38-61.43,92.38-61.43Z"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.957500db0ce40cdaa5127a0471f99cc3.svg";
export { ForwardRef as ReactComponent };